import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { postApiToken } from "../../store/action-creators";

type UseTwilioBootstrapOptions = {
  onError?: (error: unknown) => void;
};

export const useTwilioBootstrap = (
  options?: UseTwilioBootstrapOptions
): void => {
  const jwt = useSelector((s: AppState) => s.token);
  const twilioToken = useSelector((s: AppState) => s.twilio.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!jwt || twilioToken) return;

    (async () => {
      try {
        await (dispatch as any)(postApiToken());
      } catch (e) {
        console.error("Error during postApiToken:", e);
        options?.onError?.(e);
      }
    })();
  }, [jwt, twilioToken]);
};
